import styled, { keyframes } from 'styled-components';

const slideAndFade = keyframes`
  from {
    transform: translateX(-4px);
    opacity: 0;
  } to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export default styled.div.withConfig({ componentId: 'sc-1rkayzl-0' })`
  opacity: 0;
  animation: ${slideAndFade} 300ms ease-out;
  animation-fill-mode: forwards;
`;
